import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Frontpage from "./components/Frontpage";
import{ init } from '@emailjs/browser';
init("user_bsUhyBlEcvLPv87eulM1l");

const App = () => {
  return (
    <div style={{ background: "#0a0a0a", color: "#c7c5c5", minHeight: "100vh", paddingBottom: "120px" }}>
      <Header />
      <Frontpage />
      <Footer />
    </div>

  );
};

export default App;
